import firebase from '../firebase'
import { getUser } from './auth'
import 'firebase/compat/firestore';
import {query, where, getDocs, collection, doc} from 'firebase/firestore'

import { db } from '../firebase';


export const getData = async (Collectionref) => {
    try {
      var data = await Collectionref.get();
      var Data = [];
      data.forEach((element) => {
        Data.push({...element.data(), ...{"doc":element.id}});
      });
      return Data;
    } catch (error) {
      // console.log(error);
    }
};

export const getFabricDetails = async(types,category,  fabric = 0)=>{

    try{
        let Data = {}
        
        const coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;
        
        console.log("Getting fabrics for :", coll)

        const DOC  = db.collection('Fabric').doc(coll)

        for(let i = 0;i<types.length;i+=1){
            const collection = DOC.collection(types[i])
            const res = await getData(collection)
            Data[types[i]] = res
        }
        if(fabric === 1){
            
        }
        return Data
    }catch(e){
        // console.log("from getDetails-firestore ", e);
    }
}

export const getButtons = async(category)=>{
    try{
        const coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;


        const collection  = db.collection('Buttons');
        const res = await getData(collection);
        
        return res;
    } catch(e){
        console.log("from getButtons-firestore ", e);
    }

}

export const getTuxedo = async (category) => {
    try {
        const coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;

        const collection = db.collection('Fabric').doc(coll).collection('tuxedo');
        const res = await getData(collection);
        return res;
    } catch (e) {
        console.log("from getTuxedo-firestore ", e);
    }
}

export const getEmbroidery = async (category) => {
    try {
        let coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;

        coll = coll + "_collections"
        console.log("get embs", coll);
        const collection = db.collection('Fabric').doc('embroidery').collection(coll);
        const res = await getData(collection);
        return res;
    } catch (e) {
        console.log("from getEmbroidery-firestore ", e);
    }
}

export const getEmbroideryStyle = async () => {
    try {
        console.log("get emb styles");
        const collection = db.collection('Fabric').doc('embroidery').collection("styles");
        const res = await getData(collection);
        return res;
    } catch (e) {
        console.log("from getEmbroidery style-firestore ", e);
    }
}

export const getDatafromDoc = async (docref) => {
    try {
      var data = await docref.get();
      return data.data();
    } catch (error) {
      // console.log(error);
      return {"src":""}
    }
};

export const getDataFromCollection=async(Collection, typ=0)=>{
    try{
        if(typ === 0){

        }else{
            const user = getUser()

            if(user){
                // const email = user.email
                let usrid = user.email
                if(!usrid){
                    usrid = user.phoneNumber
                }
                const res = await db.collection("Users").doc(usrid).collection(Collection).get()

                return {
                    "status":true,
                    "res":res
                }
            }else{
                return {
                    "status":false,
                    "error":"User not found"
                }
            }
            
        }
    }catch(error){
        // console.log(error)
        return {
            "status":false,
            "error":"Error from DB" + error
        }
    }
}

export const getDocOnCondition = async(collection, attr, val)=>{
    try{
        const docs = await collection.where(attr, "==", val).get()
        let Docs = []
        docs.forEach((element) => {
            Docs.push({...element.data(), ...{"doc":element.id}});
        });
        return Docs
    }catch(e){
      // console.log("fetching doc names", e)
    }
  }

  export const getDocsFromQueryForFabrics = async(collName, idsArray) =>{
    try{
        const results = [];
        const chunkSize = 10;
        // Split into chunks of 10 due to Firestore 'in' query limitation
        for (let i = 0; i < idsArray.length; i += chunkSize) {
            const chunk = idsArray.slice(i, i + chunkSize);

            const docRef = doc(db, "Fabric", collName);         // points to document "B" in collection "A"
            const subCollectionRef = collection(docRef, "fabrics");
            const q = query(
                subCollectionRef,
                where("id", "in", chunk)
            );

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(doc => {
                results.push({...doc.data()});
            });
        }
        return results;
    } catch(e){
      console.log("fetching doc from query", e)
    }
  }